<template>
  <div id="message">
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
        element-loading-text="加载中..."
        element-loading-background="rgba(0, 0, 0, 0.4)"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <span>权限管理&nbsp;/&nbsp;短信管理</span>
        <el-button type="success" @click="handleEdit(1, '', 'sms:add')"
          >添加</el-button
        >
      </div>
      <div style="margin-bottom: 18px">
        <el-select
          v-model="sheng"
          placeholder="省份"
          @change="cksheng"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="shi"
          placeholder="城市"
          @change="ckshi"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="1">
        </el-table-column>
        <el-table-column prop="name" min-width="120" label="模板名称">
        </el-table-column>
        <el-table-column prop="autograph" min-width="160" label="签名">
        </el-table-column>
        <el-table-column prop="code" min-width="200" label="模板code">
        </el-table-column>
        <el-table-column prop="content" min-width="200" label="短信内容">
        </el-table-column>
        <el-table-column prop="cityName" min-width="160" label="所属地区">
        </el-table-column>
        <el-table-column prop="type" min-width="100" label="类型">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 1">初检通知</p>
            <p v-if="scope.row.type == 2">协管员审核通知</p>
            <p v-if="scope.row.type == 3">审核被驳回通知</p>
            <p v-if="scope.row.type == 4">乡厨审核通过通知</p>
            <p v-if="scope.row.type == 5">药食所审核通知</p>
            <p v-if="scope.row.type == 6">验证码</p>
            <p v-if="scope.row.type == 7">食安办复查通过</p>
            <p v-if="scope.row.type == 8">食安办复查驳回</p>
            <p v-if="scope.row.type == 9">通知食安办人员</p>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(2, scope.row, 'sms:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row, 'sms:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ total }}</i> 条</span
        >
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="短信管理/编辑"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <p><span>*</span> accesskeyid</p>
      <el-input
        v-model="details.accesskeyid"
        placeholder="请输入accesskeyid"
      ></el-input>
      <p><span>*</span> accesskeysecret</p>
      <el-input
        v-model="details.accesskeysecret"
        placeholder="请输入accesskeysecret"
      ></el-input>
      <p><span>*</span> 签名</p>
      <el-input v-model="details.autograph" placeholder="请输入签名"></el-input>
      <p><span>*</span> 模板code</p>
      <el-input v-model="details.code" placeholder="请输入模板code"></el-input>
      <p><span>*</span> 模板内容</p>
      <el-input
        class="margin: 10px 0;"
        v-model="details.content"
        placeholder="请输入模板内容"
        :rows="6"
        type="textarea"
      ></el-input>
      <p><span>*</span> 模板名称</p>
      <el-input v-model="details.name" placeholder="请输入模板名称"></el-input>
      <p style="margin-top: 14px"><span>*</span> 类型选择</p>
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.type"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>
      <div>
        <p style="margin: 12px 0px"><span>*</span> 地区分配</p>
        <el-select
          v-model="sheng1"
          placeholder="省份"
          @change="addsheng"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="shi1"
          placeholder="城市"
          @change="addshi"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="newbtn" @click="update">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Paging from "@/components/Paging";
export default {
  components: {
    Paging,
  },
  name: "message",
  data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      title: "",
      titles: "",
      content: "",
      stat: "",
      type: "",
      options: [
        { type: 1, name: "初检通知" },
        { type: 2, name: "协管员审核通知" },
        { type: 3, name: "审核被驳回通知" },
        { type: 4, name: "乡厨审核通过通知" },
        { type: 5, name: "药食所审核通知" },
        { type: 6, name: "验证码" },
        { type: 7, name: "食安办复查通过" },
        { type: 8, name: "食安办复查驳回" },
        { type: 9, name: "通知食安办人员" },
      ],
      userdata: [],
      id: "",
      btn: [],
      fullscreenLoading: true,
      value: "",
      pageNum: 1,
      pageSize: 10,
      sheng: "",
      shi: "",
      shenglist: [],
      shilist: [],
      areaId: "", //筛选的id
      xy: "",
      sheng1: "",
      shi1: "",
      total: 0,

      details: {},
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.loadpage();
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      this.region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
        }
      });
    }
  },
  methods: {
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.loadpage();
    },
    addsheng() {},
    addshi() {},
    loadpage() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId: this.areaId,
        adminAreasId: userdata.areasId,
      });
      this.$axios
        .post(`/api-r/sms/getSmsList`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          // console.log(res,'短信列表')
          this.$set(this, "tableData", res.data.pageInfo.list);
          this.$set(this, "total", res.data.pageInfo.total);
        });
    },
    reset() {
      this.$router.push("/refresh");
    },
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.loadpage();
    },
    cksheng(val) {
      this.$set(this, "shi", "");
      this.areaId = val;
    },
    ckshi(val) {
      this.areaId = val;
    },
    handleEdit(stat, row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$set(this, "stat", stat);
      this.dialogFormVisible = true;
      if (stat == 2) {
        let arr = row.cityId.split(",");
        this.$set(this, "details", row);
        this.$set(this, "value", row.type);
        this.$set(this, "sheng1", Number(arr[0]));
        this.$set(this, "shi1", Number(arr[1]));
      } else {
        this.$set(this, "details", {});
        this.$set(this, "value", "");
        this.$set(this, "sheng1", "");
        this.$set(this, "shi1", "");
      }
    },
    handleDelete(row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/sms/deleteSms/${row.id}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.$router.replace({
                  path: "/refresh",
                  query: {
                    t: Date.now(),
                  },
                });
              }
            });
        })
        .catch(() => {});
    },
    datalist(a) {
      if (a == undefined || a == "") {
        this.$message("请完善信息");
      }
    },
    // 更新and添加协议
    update() {
      if (
        this.details.accesskeyid == undefined ||
        this.details.accesskeyid == ""
      ) {
        this.$message("请完善信息");
        return;
      }
      if (
        this.details.accesskeysecret == undefined ||
        this.details.accesskeysecret == ""
      ) {
        this.$message("请完善信息");
        return;
      }
      if (this.details.autograph == undefined || this.details.autograph == "") {
        this.$message("请完善信息");
        return;
      }
      if (this.details.code == undefined || this.details.code == "") {
        this.$message("请完善信息");
        return;
      }
      if (this.details.content == undefined || this.details.content == "") {
        this.$message("请完善信息");
        return;
      }
      if (this.details.name == undefined || this.details.name == "") {
        this.$message("请完善信息");
        return;
      }
      if (this.value == undefined || this.value == "") {
        this.$message("请完善信息");
        return;
      }
      if (this.shi1 == "") {
        return this.$message("请选择城市分配");
      }
      let arr = [];
      let arr1 = [];
      this.shilist.forEach((x) => {
        if (x.id == this.shi1) {
          arr.push(this.shenglist[0].id, this.shi1);
          arr1.push(this.shenglist[0].name, x.name);
        }
      });
      let cityId = arr.join(",");
      let cityName = arr1.join(",");
      this.details.cityId = cityId;
      this.details.cityName = cityName;
      this.details.type = this.value;
      let url = "";
      let newdata = this.details;
      // console.log(this.details)
      if (this.stat == 1) {
        url = "/api-r/sms/addSms";
      } else {
        url = `/api-r/sms/updateSms`;
      }
      this.$axios
        .post(url, this.$qs.stringify(newdata), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          if (res.data.success == true) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.$router.replace({
              path: "/refresh",
              query: {
                t: Date.now(),
              },
            });
          } else {
            alert(res.data.msg);
          }
        });
    },
  },
};
</script>
<style>
#message .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#message .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#message .el-input--mini {
  margin-top: -12px;
}
#message .el-dialog__body > P {
  margin: 12px 0px;
}
</style>
<style scoped lang="scss">
p > span {
  color: red;
}
.newbtn {
  background-color: #11A983;
  color: #fff;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
